module.exports = __webpack_public_path__ + "static/media/longines-lepine.b9b96087.jpg";